import React from 'react';
import { BroadcastEventType } from '@cotera/api';
import { useEvents } from '../hooks/use-events';

/**
 * Establishes the WebSocket connection for broadcast events and emits to the
 * broadcast-event-bus. EventWatchables subscribe to that bus, so they receive
 * events without needing useEvents in each component.
 *
 * Mount at org level (inside CurrentOrgProvider) so EventWatchables work
 * wherever broadcast events are needed (e.g. CocoChat).
 */
export const EventsProvider: React.FC<{
  children: React.ReactNode;
  eventTypes: (typeof BroadcastEventType)[keyof typeof BroadcastEventType][];
}> = ({ children, eventTypes }) => {
  useEvents({
    eventTypes,
  });
  return <>{children}</>;
};
